"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _type = require("../actions/ui/type");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var feedbackQuestionsReducer = function feedbackQuestionsReducer(state, _ref) {
  var type = _ref.type,
    payload = _ref.payload;
  var currentFeedbackState = state;
  switch (type) {
    case _type.SHOW_SUCCESS_NOTIFICATION:
      return _objectSpread(_objectSpread({}, currentFeedbackState), {}, {
        isSuccessNotificationShown: true
      });
    case _type.HIDE_SUCCESS_NOTIFICATION:
      return _objectSpread(_objectSpread({}, currentFeedbackState), {}, {
        isSuccessNotificationShown: false
      });
    case _type.SHOW_FAILURE_NOTIFICATION:
      return _objectSpread(_objectSpread({}, currentFeedbackState), {}, {
        isFailureNotificationShown: true
      });
    case _type.IS_GET_QUESTIONS_INPROGRESS:
      return _objectSpread(_objectSpread({}, currentFeedbackState), {}, {
        isGetQuestionsInProgress: payload
      });
    case _type.IS_SUBMIT_INPROGRESS:
      return _objectSpread(_objectSpread({}, currentFeedbackState), {}, {
        isSubmitInProgress: payload
      });
    case _type.IS_SURVEY_ENABLED:
      return _objectSpread(_objectSpread({}, currentFeedbackState), {}, {
        isSurveyEnabled: payload
      });
    case _type.IS_SURVEY_SUBMITTED:
      return _objectSpread(_objectSpread({}, currentFeedbackState), {}, {
        isSurveySubmitted: payload
      });
    default:
      return currentFeedbackState;
  }
};
var _default = exports["default"] = feedbackQuestionsReducer;
//# sourceMappingURL=ui.js.map